import React, {useCallback, useEffect, useMemo, useState} from 'react';
import { useParams } from 'react-router-dom';
import styles from './matchPage.module.css';
import MatchSquads from '../matchSquads/matchSquads';
import HeaderMatch from '../headerMatch/headerMatch';
import fetchMatchEvents from '../../api/fetchMatchEvents';
import { MatchEventsInterface } from '../../utils/types';
import MatchEvents from "../matchEvents/matchEvents";
import {useGetMatches} from "../../hooks/useGetMatches";

interface Score {
	home: number;
	away: number;
}

interface ScoreEvent {
	type: 'goal' | 'owngoal' | 'penalty kick' | 'penalty shoot-out goal';
	team: 'home' | 'away';
	time: number | string;
	playerName: string;
	icon: string;
}

function convertMatchToObject(match:any) {
	// Если match уже является объектом, возвращаем его как есть
	if (typeof match === 'object' && match !== null && !Array.isArray(match)) {
		return match;
	}
}
const MatchPage: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const [eventsData, setEventsData] = useState<MatchEventsInterface[]>([]);
	const [score, setScore] = useState<Score>({ home: 0, away: 0 });
	const [scoreEvents, setScoreEvents] = useState<ScoreEvent[]>([]);
	const [penaltyShootOutScore, setPenaltyShootOutScore] = useState<Score>({ home: 0, away: 0 });

	const handleScoreUpdate = useCallback((
		newScore: Score,
		newPenaltyShootOutScore: Score,
		newScoreEvents: ScoreEvent[],
		newPenaltyShootOutEvents: ScoreEvent[]
	) => {
		setScore(newScore);
		setPenaltyShootOutScore(newPenaltyShootOutScore);
		setScoreEvents(newScoreEvents);
		// можно сохранить newPenaltyShootOutEvents в состоянии, вопрос – зачем?
	}, []);

	const matchOptions = useMemo(() => ({
		matchIds: [Number(id)]
	}), [id]);

	const {
		matches: matches,
		loading: matchesLoading,
		error: matchesError
	} = useGetMatches(matchOptions);


	const match = convertMatchToObject(matches[0]);

	// Fetch match events data when match data is available
	useEffect(() => {
		if (match) {
			if (match.periods && match.periods.length > 0) {
				const fetchEventsData = async () => {
					try {
						const events = await fetchMatchEvents(match.periods);
						setEventsData(events);
						console.log('Fetched match events:', events);
					} catch (error) {
						console.error('Error fetching match events:', error);
					}
				};

				fetchEventsData();
			}
		}
	}, [match]);

	if (!match) {
		return <div>No match data available</div>;
	}


	const matchTeams = {
		host_club__logo: match.host_club_logo,
		host_club__name: match.host_team_name,
		host_club__id: match.host_team_id,
		guest_club__logo: match.guest_club_logo,
		guest_club__name: match.guest_team_name,
		guest_club__id: match.guest_team_id
	}

	return (
		<>
			<HeaderMatch
				match={match}
				score={score}
				scoreEvents={scoreEvents}
				penalties={penaltyShootOutScore}
			/>
			<main>
				<div className={styles.matchPage}>
					<section className={styles.teams}>
							<div key={match.id} className={styles.section_caption}>
								<img src={match.host_club_logo} alt={match.host_team_name} />
								<h2>Состав на матч</h2>
								<img src={match.guest_club_logo} alt={match.guest_team_name} />
							</div>
						<MatchSquads matchId={match.id} homeTeam={match.host_team_name} awayTeam={match.guest_team_name} />
					</section>

					<section className={styles.context}>
						<MatchEvents matchEvents={eventsData} matchTeams={matchTeams} onScoreUpdate={handleScoreUpdate} />
					</section>
				</div>
			</main>
		</>
	);
};

export default MatchPage;
